<script>
export default {
    name: 'footer',
}
</script>

<template lang="pug">
    .justfit-footer.text-center
        //- .mb-4
        //-     a(href="/") {{ $t('BASE.RULES') }}
        .my-1
            a(href="tel:+36706669988") +36-70-666-9988
        .my-1
            a(href="mailto:info@justfitart.com") info@justfitart.com
        p.my-1 Copyright © 2019 Justfit Technology LLC

</template>

<style lang="scss">
    @import "../../assets/styles/settings/settings";

    .justfit-footer {
        background-color: $black;
        padding: rem(50) rem(16);
        color: #858484;
        font-size: 14px;
        a {
            color: #858484;
        } 
    }
</style>
